export const layoutElements = {
  HEADER: 'header',
  BODY: 'body',
  FOOTER: 'footer',
}
